module.exports = __webpack_public_path__ + "static/media/How to send email.3d1064fa.png";